import React from "react";

// The Sofascore widget renders its own "Sofascore · Never miss" branding footer
// below the table. That footer lives inside a cross-origin iframe (can't be removed
// from the DOM), so we clip it by capping the wrapper height with overflow:hidden.
// `visibleHeight` also lets us render a compact "snapshot" (top rows only).
export const SofascoreStandings = ({ visibleHeight = 915 }) => (
  <div data-testid="sofascore-standings">
    <div
      className="rounded-sm overflow-hidden border border-pslborder bg-white"
      style={{ height: visibleHeight, maxWidth: "768px" }}
    >
      <iframe
        id="sofa-standings-embed-60133-88317"
        title="Premier Soccer League 2026 — live standings"
        src="https://widgets.sofascore.com/en/embed/tournament/60133/season/88317/standings/Premier%20Soccer%20League%202026?widgetTitle=Premier%20Soccer%20League%202026&showCompetitionLogo=true"
        style={{ height: "1043px", maxWidth: "768px", width: "100%", border: 0 }}
        frameBorder="0"
        scrolling="no"
      />
    </div>
  </div>
);
